module.exports = __webpack_public_path__ + "static/media/dry-cupping.21bb755f.webp";